import React from "react";
import T from "prop-types";
import Map from "immutable";
import { ConfirmAction, Icon } from "MODULES/shared/components";
import { renderIf, toggleSwitch } from "MODULES/shared/decorators";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { LINE_ITEMS, OUTRIGHT_SALE } from "APP_ROOT/constants";
import { CONSIGNMENT_TYPE, INVENTORY } from "MODULES/inventories/constants";

function ReverseCancellation({ toggle, unCancelling, ...rest }) {
  return (
    <DropDownItem onClick={toggle}>
      <Modal {...rest} open={unCancelling} />
      <span className="text-danger">
        <Icon name="undo" fixed />
        &nbsp;Reverse SO Cancellation
      </span>
    </DropDownItem>
  );
}

ReverseCancellation.propTypes = {
  toggle: T.func.isRequired,
  unCancelling: T.func.isRequired
};

function Modal({ open, reverseCancellation, salesOrder, close }) {
  return (
    <ConfirmAction
      onConfirm={() => reverseCancellation(salesOrder.get("id"))}
      close={close}
      open={open}
      icon={<Icon name="undo" fixed />}
      btnText="Yes, Reverse Cancellation"
      title="Reverse Cancellation"
    >
      <strong>Heads up!</strong>
      &nbsp; This will reverse the cancellation of this Sales Order.
    </ConfirmAction>
  );
}

Modal.propTypes = {
  open: T.func.isRequired,
  close: T.func.isRequired,
  reverseCancellation: T.func.isRequired,
  salesOrder: T.instanceOf(Map)
};

const ifValid = renderIf(({ salesOrder }) =>
  salesOrder
    .get(LINE_ITEMS, [])
    .every(
      l => !l.getIn([INVENTORY, CONSIGNMENT_TYPE]) && !l.get(OUTRIGHT_SALE)
    )
);

export default withSalesOrder(
  ifValid(toggleSwitch("unCancelling")(ReverseCancellation))
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/CancellationReversal/Modal.jsx